import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';
import Payment, { ShopProduct } from '../../../interfaces/Payment';

@Component({
  template: require('./practicum-page.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
})
export class PracticumPage extends vue {


  days = '';
  paymentsProvider = IocContainer.get<Payment>(SERVICES.PAYMENT);
  practicumProduct: ShopProduct = null;

  async mounted() {
    try {
      const products = await this.paymentsProvider.getProducts();
      this.practicumProduct = products.find(p => p.type === 'practicum') || null;
    } catch (e) {
      this.practicumProduct = null;
    }
  }
  get practicumPriceLabel() {
    return this.practicumProduct
      ? '$' + Number(this.practicumProduct.price).toFixed(2) + ' ' + this.practicumProduct.currency.toUpperCase()
      : 'listed at checkout';
  }
  // Preloader
  get loading() {
    return this.$store.state.loadingUser;
  }  
  get expiration() {
    return this.$store.state.user.expiration;
  }
  get userData() {
    return this.$store.state.user;
  }
  setDays(e) {
    this.days = e.target.value;
  }

  openCheckout() {
    this.$router.push({ name: 'checkout', params: { product: 'practicum', name: "Practicum" } });
  }
  redirectHome(){
    this.$router.push({ name: 'course' })
  }
}
